(function () {
    'use strict';

    angular.module("imApp").factory("custactAcMatchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3201,
                    parameters: parms || {}
                });
            },
            approveObj: function (setting) {
                return $ihttp.post({
                    method: 3202,
                    parameters: setting
                });
            },
            unapproveObj: function (setting) {
                return $ihttp.post({
                    method: 3204,
                    parameters: setting
                });
            },
            distributeToGrid: function (setting) {
                return $ihttp.post({
                    method: 3203,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
